<template>
  <div 
    class="  px-10 mt-12">
    <v-layout wrap>
      <v-flex>
        <section>

          <v-dialog v-model="dialog.status"
            @keydown.esc="dialog.status = false"
            :fullscreen="dialog.fullscreen"
            width="500"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
              class="pa-8 pt-6">
              <v-card-title 
                class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
                
                Mengubah Status
  
                <v-spacer/>
  
                <!-- <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  color="#718EBF">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon> -->
  
                <v-icon 
                  @click="dialog.status = false; dialog.fullscreen = false; message.status = ''; message.error = ''"
                  class="cursor-pointer"
                  size="18"
                  color="#000000">
                  mdi-close
                </v-icon>
              </v-card-title>
              
              <!-- <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->
  
              <v-card-text 
                class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
                Apakah Anda yakin mengubah status perubahan data menjadi <b class="font-weight-bold black--text">dipersiapkan / Diterima Warehouse</b> ?

  
                <div v-if="message.error.length > 0"
                  class="text-left mt-4">
                  <div
                    class="error--text d-flex align-start">
                    <v-icon size="18" color="red" style="padding-top: 5px;">mdi-alert-circle-outline</v-icon>
                    
                    <span
                      class="ml-1">
                      {{ message.error }}
                    </span>
                  </div>
                </div>
              </v-card-text>
  
  
              <!-- <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->
  
              <v-card-actions
                class="pa-0 pt-4">
                <v-spacer/>
  
                <v-btn
                  rounded
                  @click="save()"
                  :loading="process.form"
                  :disabled="process.form"
                  width="190"
                  height="45"
                  elevation="0"
                  color="#1814F3"
                  class="fs-16 white--text text-capitalize border-radius">
                  Ya, {{ message.status }}
                </v-btn>
  
                <!-- <v-btn
                  rounded
                  width="120"
                  @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
                  :disabled="process.status"
                  outlined
                  class="body-2 font-weight-bold text-capitalize red--text">
                  Batal
                </v-btn> -->
              </v-card-actions>
            </v-card>
          </v-dialog>
          
          <div class="color-dark-blue fs-22 font-weight-bold mb-6">
            Detail Approval Order
          </div>

          <v-row
            class="mt-3">
            <v-col 
              cols="12"
              class="py-0">

              <div class="mt-0" v-if="detail.status === 'approved'">
                <v-card flat style="border-radius: 25px; border: 1px solid #E7E7E7;" class="pb-7">
                  <v-card-text>
                    <div class="fs-18 input-label mb-8">
                      Detail Produk
                    </div>
                    <!-- <v-divider class="my-4"></v-divider> -->

                    <ValidationObserver 
                      ref="form">
                      <v-form>
                        <div v-for="(item, index) in detail.detail" :key="index">
                          <v-card flat class="mb-5" style="background: #718ebf17; border-radius: 15px;">
                            <v-card-text>
                              <div class="fs-16 font-weight-bold label-input">
                                {{ item.detail_varian_name }}
                              </div>
                              <div>
                                <span>Kode SKU</span>: <span>{{ item.detail_varian_sku }}</span>
                              </div>
                              <div style="width: 150px; border: 1px solid #E7E7E7; border-radius: 15px; background: #fff;" class="text-center pa-5 pt-2 mt-3">
                                <div class="mb-3">Stok</div> 
                                <div class="fs-20 font-weight-bold mb-2">{{ item.stok_pcs | number }} Pcs</div>
                              </div>
                              <div class="mt-3">
                                <div class="fs-12">
                                  Catatan
                                </div>
                                <div class="font-weight-bold">
                                  Stok Lusin : {{ item.stok_lusin | number }} Lusin
                                </div>
                                <div class="font-weight-bold">
                                  Stok Dus : {{ item.stok_dus | number }} Dus
                                </div>
                                <div class="font-weight-bold">
                                  1 Dus = {{item.detail_total_in_dus}} Pcs
                                </div>
                              </div>
                              <!-- <div>
                                <span>Harga</span>: <span>{{ item.price | price }}</span>
                              </div> -->
                              <v-row class="pt-3 pb-2">
                                <v-col class="py-0" cols="2">
                                  Qty
                                </v-col>
                                <v-col class="py-0">
                                  Qty Akan Dikirim
                                </v-col>
                              </v-row>

                              <v-row class="" v-if="item.detail_qty_pcs*1 > 0">
                                <!-- <v-col>
                                  <div class="fs-15 label-input">
                                    Harga
                                  </div>
          
                                  <div class="fs-19 font-weight-bold label-input mt-5">
                                    {{ item.price | price }}
                                  </div>
                                </v-col> -->

                                <v-col class="py-0" cols="2">
                                  <!-- <div 
                                    class="fs-15 label-input">
                                    Qty Pcs
                                  </div> -->
            
                                  <div class="fs-19 font-weight-bold label-input mt-2">
                                    {{ item.detail_qty_pcs }} Pcs
                                  </div>
                                </v-col>
                                <v-col class="py-0">
                                  <div style="width: 200px" v-if="detail.persiapan_date == ''">
                                    <ValidationProvider
                                      :name="`Qty diterima Pcs ${item.detail_varian_name}`" 
                                      :rules="`required|min_value:1|max_value:${(item.stok_pcs*1) < item.detail_qty_pcs*1 ? item.stok_pcs*1 : item.detail_qty_pcs*1}`"
                                      v-slot="{ errors }">
                
                                      <v-currency-field
                                      
                                        filled
                                        rounded
                                        dense
                                        solo
                  
                                        color="#718EBF"
                                        placeholder="Qty"
                                        suffix="pcs"
                                        :readonly="detail.persiapan_date !== ''"
  
                                        
                  
                                        v-model="item.qty_pcs_approve"
                                        :error-messages="errors"
                                        required
                                        style="border-radius: 10px;">
                                      </v-currency-field>
                                    </ValidationProvider>
                                  </div>

                                  <div class="fs-19 font-weight-bold label-input mt-2" v-if="detail.persiapan_date !== ''">
                                    {{ item.qty_pcs_approve }} Pcs
                                  </div>
                                </v-col>

                                <!-- <v-col>
                                  <div class="fs-15 label-input">
                                    Harga Beli
                                  </div>
          
                                  <v-currency-field
                                    
                                    filled
                                    rounded
                                    dense
                                    solo
              
                                    color="#718EBF"
                                    placeholder="Harga Beli"
                                    
              
                                    v-model="item.harga_beli"
                                    required
                                    style="border-radius: 10px;">
                                  </v-currency-field>
                                </v-col>

                                <v-col>
                                  <div class="fs-15 label-input">
                                    PPN Beli
                                  </div>
          
                                  <v-currency-field
                                    
                                    filled
                                    rounded
                                    dense
                                    solo
              
                                    color="#718EBF"
                                    placeholder="PPN Beli"
                                    
              
                                    v-model="item.ppn_beli"
                                    required
                                    style="border-radius: 10px;">
                                  </v-currency-field>
                                </v-col> -->
                              </v-row>

                              <v-row v-if="item.detail_qty_lusin*1 > 0">
                                <!-- <v-col>
                                  <div class="fs-15 label-input">
                                    Harga
                                  </div>
          
                                  <div class="fs-19 font-weight-bold label-input mt-5">
                                    {{ item.price | price }}
                                  </div>
                                </v-col> -->

                                <v-col class="py-0" cols="2">
                                  <!-- <div 
                                    class="fs-15 label-input">
                                    Qty Lusin
                                  </div> -->
            
                                  <div class="fs-19 font-weight-bold label-input mt-5">
                                    {{ item.detail_qty_lusin }} Lusin
                                  </div>
                                  <!-- <div class="fs-15 label-input">
                                    Qty
                                  </div>
          
                                  <v-currency-field
                                    
                                    filled
                                    rounded
                                    dense
                                    solo
              
                                    color="#718EBF"
                                    placeholder="Qty"

                                    
              
                                    v-model="item.qty"
                                    required
                                    style="border-radius: 10px;">
                                  </v-currency-field> -->
                                </v-col>
                                <v-col class="py-0">
                                  <div style="width: 200px" v-if="detail.persiapan_date == ''">
                                    <ValidationProvider
                                      :name="`Qty diterima Lusin ${item.detail_varian_name}`" 
                                      :rules="`required|min_value:1|max_value:${item.stok_lusin*1 < item.detail_qty_lusin*1 ? item.stok_lusin*1 : item.detail_qty_lusin*1}`"
                                      v-slot="{ errors }">
                                      <!-- <div 
                                        class="fs-15 label-input">
                                        Qty Approve Lusin
                                      </div> -->
                
                                      <v-currency-field
                                      
                                        filled
                                        rounded
                                        dense
                                        solo
                  
                                        color="#718EBF"
                                        placeholder="Qty"
                                        :readonly="detail.persiapan_date !== ''"
                                        suffix="lusin"
                                        
                  
                                        v-model="item.qty_lusin_approve"
                                        :error-messages="errors"
                                        required
                                        style="border-radius: 10px;">
                                      </v-currency-field>
                                    </ValidationProvider>
                                  </div>

                                  <div class="fs-19 font-weight-bold label-input mt-5" v-if="detail.persiapan_date !== ''">
                                    {{ item.qty_lusin_approve }} Lusin
                                  </div>
                                </v-col>

                                <!-- <v-col>
                                  <div class="fs-15 label-input">
                                    Harga Beli
                                  </div>
          
                                  <v-currency-field
                                    
                                    filled
                                    rounded
                                    dense
                                    solo
              
                                    color="#718EBF"
                                    placeholder="Harga Beli"
                                    
              
                                    v-model="item.harga_beli"
                                    required
                                    style="border-radius: 10px;">
                                  </v-currency-field>
                                </v-col>

                                <v-col>
                                  <div class="fs-15 label-input">
                                    PPN Beli
                                  </div>
          
                                  <v-currency-field
                                    
                                    filled
                                    rounded
                                    dense
                                    solo
              
                                    color="#718EBF"
                                    placeholder="PPN Beli"
                                    
              
                                    v-model="item.ppn_beli"
                                    required
                                    style="border-radius: 10px;">
                                  </v-currency-field>
                                </v-col> -->
                              </v-row>

                              <v-row v-if="item.detail_qty_dus*1 > 0">
                                <!-- <v-col>
                                  <div class="fs-15 label-input">
                                    Harga
                                  </div>
          
                                  <div class="fs-19 font-weight-bold label-input mt-5">
                                    {{ item.price | price }}
                                  </div>
                                </v-col> -->

                                <v-col class="py-0" cols="2">
                                  <!-- <div 
                                    class="fs-15 label-input">
                                    Qty Dus 
                                  </div> -->
                                  <div class="fs-19 font-weight-bold label-input mt-5">
                                    {{ item.detail_qty_dus }} Dus
                                  </div>
              
                                    
                                  <!-- <div class="fs-15 label-input">
                                    Qty
                                  </div>
          
                                  <v-currency-field
                                    
                                    filled
                                    rounded
                                    dense
                                    solo
              
                                    color="#718EBF"
                                    placeholder="Qty"

                                    
              
                                    v-model="item.qty"
                                    required
                                    style="border-radius: 10px;">
                                  </v-currency-field> -->
                                </v-col>
                                <v-col class="py-0">
                                  <div style="width: 200px" v-if="detail.persiapan_date == ''">
                                    <ValidationProvider
                                      :name="`Qty diterima Dus ${item.detail_varian_name}`" 
                                      :rules="`required|min_value:1|max_value:${item.stok_dus*1 < item.detail_qty_dus*1 ? item.stok_dus*1 : item.detail_qty_dus*1}`"
                                      v-slot="{ errors }">
                                      <!-- <div 
                                        class="fs-15 label-input">
                                        Qty Approve Dus
                                      </div> -->
                
                                      <v-currency-field
                                      
                                        filled
                                        rounded
                                        dense
                                        solo
                                        :readonly="detail.persiapan_date !== ''"
                                        suffix="dus"
                                        color="#718EBF"
                                        placeholder="Qty"
  
                                        
                  
                                        v-model="item.qty_dus_approve"
                                        :error-messages="errors"
                                        required
                                        style="border-radius: 10px;">
                                      </v-currency-field>
                                    </ValidationProvider>
                                  </div>

                                  <div class="fs-19 font-weight-bold label-input mt-5" v-if="detail.persiapan_date !== ''">
                                    {{ item.qty_dus_approve }} Dus
                                  </div>
                                </v-col>

                                <!-- <v-col>
                                  <div class="fs-15 label-input">
                                    Harga Beli
                                  </div>
          
                                  <v-currency-field
                                    
                                    filled
                                    rounded
                                    dense
                                    solo
              
                                    color="#718EBF"
                                    placeholder="Harga Beli"
                                    
              
                                    v-model="item.harga_beli"
                                    required
                                    style="border-radius: 10px;">
                                  </v-currency-field>
                                </v-col>

                                <v-col>
                                  <div class="fs-15 label-input">
                                    PPN Beli
                                  </div>
          
                                  <v-currency-field
                                    
                                    filled
                                    rounded
                                    dense
                                    solo
              
                                    color="#718EBF"
                                    placeholder="PPN Beli"
                                    
              
                                    v-model="item.ppn_beli"
                                    required
                                    style="border-radius: 10px;">
                                  </v-currency-field>
                                </v-col> -->
                              </v-row>

                            </v-card-text>
                          </v-card>
                        </div>
                      </v-form>
                    </ValidationObserver>
                  </v-card-text>
                </v-card>
              </div>


              <v-card 
                flat
                class="mt-5"
                style="border-radius: 25px; border: 1px solid #E7E7E7;">
                <v-card-text
                  v-if="process.load" 
                  class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <div class="mb-2 title">
                      Mohon Tunggu...
                    </div>
                    <v-progress-circular
                      indeterminate
                    ></v-progress-circular>
                  </div>
                </v-card-text>

                <v-card-text v-if="!process.load && Object.keys(detail).length > 0" >
                  <v-row>
                    <v-col cols="12">
                      <div class="font-weight-bold">
                        Customers :
                      </div>
                    </v-col>
                    <v-col cols="12" md="6" class="pt-0">
                      <div>
                        <div class="fs-15 font-weight-bold">
                          {{ detail.customer_name }}
                        </div>
                        <div class="text-lowercase">
                          {{ detail.shipping_address }}, kel. {{ detail.shipping_village }}, kec. {{ detail.shipping_subdistrict }}
                          Kab. {{ detail.shipping_city }} - {{ detail.shipping_province }}
                        </div>
                      </div>
                      <table>
                        <tr>
                          <td class="">
                            Nama Toko
                          </td>
                          <td style="width: 40px" class="text-center">
                            : 
                          </td>
                          <td class="text-left font-weight-bold">
                            {{ detail.store_name }}
                          </td>
                        </tr>
                        <tr>
                          <td class="">
                            Tipe Toko
                          </td>
                          <td style="width: 40px" class="text-center">
                            :
                          </td>
                          <td class="text-left font-weight-bold">
                            {{ detail.store_type }}
                          </td>
                        </tr>
                      </table>
                    </v-col>
                    <v-col cols="12" md="6" class="d-flex justify-end pt-0">
                      <div>
                        <table style="width: 100%;">
                          <tr>
                            <td class="font-weight-bold">
                              Nomer Order
                            </td>
                            <td style="width: 80px" class="text-center">
                              : 
                            </td>
                            <td class="text-right">
                              {{ detail.number }}
                            </td>
                          </tr>
                          <tr>
                            <td class="font-weight-bold">
                              Tanggal Order
                            </td>
                            <td style="width: 80px" class="text-center">
                              :
                            </td>
                            <td class="text-right">
                              {{ detail.input_datetime | datetime }}
                            </td>
                          </tr>
                          <tr>
                            <td class="font-weight-bold">
                              Nama Sales
                            </td>
                            <td style="width: 80px" class="text-center">
                              : 
                            </td>
                            <td class="text-right">
                              {{ detail.sales_name }}
                            </td>
                          </tr>
                          <tr>
                            <td class="font-weight-bold">
                              Order By
                            </td>
                            <td style="width: 80px" class="text-center">
                              : 
                            </td>
                            <td class="text-right">
                              {{ detail.orders_by === 'sales' ? detail.sales_name : detail.orders_by === 'customer' ? detail.customer_name : detail.orders_by }} <span class="text-capitalize">( {{ detail.orders_by }} )</span>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </v-col>
                    <v-col cols="12" class="my-8">
                      <div style="overflow: auto; ">
                        <table style="width: 100%;">
                          <tr>
                            <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                              Kode Barang
                            </td>
                            <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                              Nama Barang
                            </td>
                            <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                              Quantity
                            </td>
                            <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center" v-if="detail.persiapan_date !== ''">
                              Quantity Akan Dikirm
                            </td>
                          </tr>
                          <tr v-for="(item, index) in detail.detail" :key="index">
                            <td style="border: 1px solid #ededed; padding: 10px;" class="">
                              {{ item.detail_varian_sku }}
                            </td>
                            <td style="border: 1px solid #ededed; padding: 10px;" class="">
                              {{ item.detail_varian_name }}
                            </td>
                            <td style="border: 1px solid #ededed; padding: 10px;" class="">
                              {{ `${(item.detail_total_in_dus*1) === 1 ? 0 : item.detail_qty_dus}.${item.detail_qty_lusin}.${(item.detail_total_in_dus*1) === 1 ? item.detail_qty_dus : item.detail_qty_pcs}` }}
                            </td>
                            <td style="border: 1px solid #ededed; padding: 10px;" class="" v-if="detail.persiapan_date !== ''">
                              {{ `${item.qty_dus_approve*1}.${item.qty_lusin_approve*1}.${item.qty_pcs_approve*1}` }}
                            </td>
                          </tr>
                        </table>
                      </div>
                    </v-col>
                    <v-col cols="12" md="6">
                      <div>
                        Total Item: {{ detail.detail.length }}
                      </div>
                    </v-col>
                    <!-- <v-col>
                      <div>
                        <div class="mb-1 input-label">
                          Nomer Order
                        </div>
                        <div class="fs-18 font-weight-bold">
                          {{ detail.number }}
                        </div>
                      </div>
                    </v-col>
                    <v-col>
                      <div>
                        <div class="mb-1 input-label">
                          Nama Sales
                        </div>
                        <div class="fs-18 font-weight-bold">
                          {{ detail.sales_name }}
                        </div>
                      </div>
                    </v-col>

                    <v-col>
                      <div>
                        <div class="mb-1 input-label">
                          Nama Customer
                        </div>
                        <div class="fs-18 font-weight-bold">
                          {{ detail.customer_name }}
                        </div>
                      </div>
                    </v-col>

                    <v-col>
                      <div>
                        <div class="mb-1 input-label">
                          Tanggal Order
                        </div>
                        <div class="fs-18 font-weight-bold">
                          {{ detail.input_datetime | date }}
                        </div>
                      </div>
                    </v-col> -->
                  </v-row>
                  <!-- <div class="fs-18 input-label mb-3">
                    Detail Order
                  </div>
                  <v-row>
                    <v-col>
                      <div>
                        <div class="mb-1 input-label">
                          Nomer Order
                        </div>
                        <div class="fs-18 font-weight-bold">
                          {{ detail.number }}
                        </div>
                      </div>
                    </v-col>
                    <v-col>
                      <div>
                        <div class="mb-1 input-label">
                          Nama Sales
                        </div>
                        <div class="fs-18 font-weight-bold">
                          {{ detail.sales_name }}
                        </div>
                      </div>
                    </v-col>

                    <v-col>
                      <div>
                        <div class="mb-1 input-label">
                          Nama Customer
                        </div>
                        <div class="fs-18 font-weight-bold">
                          {{ detail.customer_name }}
                        </div>
                      </div>
                    </v-col>

                    <v-col>
                      <div>
                        <div class="mb-1 input-label">
                          Tanggal Order
                        </div>
                        <div class="fs-18 font-weight-bold">
                          {{ detail.input_datetime | date }}
                        </div>
                      </div>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <div class="mb-2">
                        <div class="mb-1 input-label">
                          Alamat
                        </div>
                        <div class="fs-16 font-weight-bold">
                          {{ detail.shipping_address }}
                        </div>
                      </div>
                    </v-col>
                    <v-col>

                      <div class="mb-2">
                        <div class="mb-1 input-label">
                          Kelurahan
                        </div>
                        <div class="fs-16 font-weight-bold">
                          {{ detail.shipping_village }}
                        </div>
                      </div>

                      <div class="mb-2">
                        <div class="mb-1 input-label">
                          Kecamatan
                        </div>
                        <div class="fs-16 font-weight-bold">
                          {{ detail.shipping_subdistrict }}
                        </div>
                      </div>
                    </v-col>
                    <v-col>

                      <div class="mb-2">
                        <div class="mb-1 input-label">
                          Kabupaten
                        </div>
                        <div class="fs-16 font-weight-bold">
                          {{ detail.shipping_city }}
                        </div>
                      </div>

                      <div class="mb-2">
                        <div class="mb-1 input-label">
                          Provinsi
                        </div>
                        <div class="fs-16 font-weight-bold">
                          {{ detail.shipping_province }}
                        </div>
                      </div>

                    </v-col>
                    <v-col></v-col>
                  </v-row> -->
                </v-card-text>
              </v-card>

              <v-card
                flat
                class="mt-8"
                v-if="Object.keys(detail).length > 0"
                style="border-radius: 25px; border: 1px solid #E7E7E7;">
                <v-card-text>
                  <div class="fs-18 input-label mb-4">
                    Approval
                  </div>
                  <div>
                    <div>
                      Status Approval
                    </div>
                    <div class="fs-16 label-input">
                      {{ detail.status === 'proses' ? 'Proses' : detail.status === 'approved' ? 'Menunggu Approval Warehouse' : detail.status === 'persiapan' ? 'Diterima Warehouse' : detail.status === 'rejected' ? 'Ditolak' : detail.status}}
                    </div>
                  </div>
                  <div class="" v-if="detail.status === 'rejected'">
                    <div>
                      Alasan
                    </div>
                    <div class="fs-16 label-input">
                      {{ detail.rejected_reason }}
                    </div>
                  </div>
                  <v-row v-if="detail.status !== 'rejected'">

                    <v-col cols="12" md="4">
                      <v-card
                        class="pa-0"
                        height="100%"
                        flat
                        style="border-radius: 15px; border: 1px solid #E7E7E7;">
                        <v-toolbar
                          :color="set_color"
                          dark>
                          <v-toolbar-title class="body-1 font-weight-bold text-capitalize">
                            Kepala Gudang
                          </v-toolbar-title>

                          <v-spacer></v-spacer>
                          

                        </v-toolbar>

                        <!-- <v-card-text class="body-1 text-capitalize font-weight-bold pb-0">
                          General Manager
                        </v-card-text> -->

                        <v-card-text class="body-2 font-weight-light text-first">
                          <!-- <p class="mb-2">
                            <v-icon small class="mr-1">mdi-calendar-month</v-icon>
                            <span v-if="item.start === item.end">
                              Tanggal <b>{{ item.date | date }}</b>
                            </span>
                          </p> -->

                          <p class="mb-2">
                            <v-icon small class="mr-2">mdi-account</v-icon>
                            <span>
                              <b>{{ detail.persiapan_user_name.length < 1 ? '-' : detail.persiapan_user_name }}</b>
                            </span>
                          </p>

                          <p class="mb-2">
                            <v-icon small class="mr-2">mdi-calendar-month</v-icon>
                            <span>
                              <b v-if="detail.persiapan_user_name.length > 0">{{  detail.persiapan_date | date  }}</b>
                              <b v-else>-</b>
                            </span>
                          </p>


                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>

                  <v-row v-if="detail.status === 'rejected'">
                    <v-col cols="12" md="4">
                      <v-card
                        class="pa-0"
                        height="100%"
                        flat
                        style="border-radius: 15px; border: 1px solid #E7E7E7;">
                        <v-toolbar
                          :color="set_color"
                          dark>
                          <v-toolbar-title class="body-1 font-weight-bold text-capitalize">
                            Staff yg Menolak
                          </v-toolbar-title>

                          <v-spacer></v-spacer>
                          <!-- <div v-if="detail.customer_approval.General_Manager.length < 1 && user.category_user_title === 'General Manager' && detail.customer_approval.Supervisor.length < 1">
                            <v-checkbox
                              v-model="approve_name"
                              v-on-change="$emit('approved', approve_name)"
                              value="Supervisor"
                              color="white"
                              style="color: white !important"
                              hide-details
                            ></v-checkbox>
                          </div> -->

                        </v-toolbar>

                        <!-- <v-card-text class="body-1 text-capitalize font-weight-bold pb-0">
                          Supervisor
                        </v-card-text> -->

                        <v-card-text class="body-2 font-weight-light text-first">
                          <!-- <p class="mb-2">
                            <v-icon small class="mr-1">mdi-calendar-month</v-icon>
                            <span v-if="item.start === item.end">
                              Tanggal <b>{{ item.date | date }}</b>
                            </span>
                          </p> -->

                          <p class="mb-2">
                            <v-icon small class="mr-2">mdi-account</v-icon>
                            <span>
                              <b>{{ detail.user_rejected_name }}</b>
                            </span>
                          </p>

                          <p class="mb-2">
                            <v-icon small class="mr-2">mdi-calendar-month</v-icon>
                            <span>
                              <b>{{ detail.rejected_date | date  }}</b>
                            </span>
                          </p>


                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">

              <div
                v-if="detail.status === 'approved'">

                
                <div
                  v-if="user.category_user_id === '15' && detail.persiapan_date === ''"
                  class="d-flex align-center">
                  <v-btn 
                    @click="toTerima()"
                    :loading="process.load"
                    :disabled="process.load"
                    :width="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 150"
                    :height="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 45"
                    :class="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 'border-radius'"
                    elevation="0"
                    color="#1814F3"
                    class="fs-16 white--text text-capitalize">
                    Diterima
                  </v-btn>
    
                  <!-- <v-btn
                    @click="reset(); dialog.status = true; message.error = ''; message.status = 'tolak'"
                    :loading="process.load"
                    :disabled="process.load"
                    width="120"
                    height="45"
                    elevation="0"
                    color="warning"
                    class="fs-16 ml-4 white--text text-capitalize border-radius">
                    Ditolak
                  </v-btn>   -->
                </div>
              </div>

              
              <v-btn
                to="/approval/order-warehouse"
                color="red"
                elevation="0"
                :width="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 150"
                :height="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 45"
                :class="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 'border-radius'"
                class="body-2 white--text text-capitalize d-flex align-center ml-4"
                style="font-weight: 600;">
              
                  Kembali
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        approved_by: [],
        approved_reason: '',
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: false,
        modal: false,
        menu2: false,
        
        zoomed: false,
        zoomedTtd: false,
        imageAspectRatio: 1,
        imageAspectRatioTtd: 1,

        dialog: {
          status: false
        },

        detail: {},

        rejected_reason: '',

        form: {
          id: '',
          sales_id: '',
          name_alias: '',
          name: '',
          mobilephone_arr: [],
          email: '',
          nik: '',
          npwp: '',
          plafon: '',
          faktur: '',
          term: '',
          ttd: ''
        },
        category: [],
        branch: [],

        mobilephone: {
          name: '',
          id: ''
        },

        upload: {
          ttd: null,
          image_url: null
        },

        process: {
          form: false,

          load: false,

          image_url: false
        },
        
        message: {
          success: '',
          error: '',
          status: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        this.process.load = true
        let params = {
          id: this.$route.params.id
        }

        await get('admin/order/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            let data = []
            res.results.data.detail.map((item) => {
              data.push(item)
            })
            this.detail = res.results.data

            this.detail.detail = []
            data.map((item) => {
              this.detail.detail.push({
                ...item,
                qty_pcs_approve: item.detail_qty_pcs_approved*1 === 0 ? item.detail_qty_pcs === 0 ? 0 : item.detail_qty_pcs*1 : item.detail_qty_pcs_approved,
                qty_lusin_approve: item.detail_qty_lusin_approved*1 === 0 ? item.detail_qty_lusin === 0 ? 0 : item.detail_qty_lusin*1 : item.detail_qty_lusin_approved,
                qty_dus_approve: item.detail_qty_dus_approved*1 === 0 ? item.detail_qty_dus === 0 ? 0 : item.detail_qty_dus*1 : item.detail_qty_dus_approved,
                stok_pcs: 0,
                stok_lusin: 0,
                stok_dus: 0
              })
            })

            if (this.$refs.form) this.$refs.form.reset()

            for (let i = 0; i < this.detail.detail.length; i++) {
              this.fetchStok(i)
            }

          }
          this.process.load = false
        })
      },

      async fetchStok (index) {
        this.process.load = true
        let params = {
          varian_id: this.detail.detail[index].detail_varian_id
        }

        await get('admin/stock/data_stock', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.detail.detail[index].stok_pcs = res.results.data[0].saldo*1
            this.detail.detail[index].stok_lusin = Math.floor(res.results.data[0].saldo/12)
            this.detail.detail[index].stok_dus = Math.floor(res.results.data[0].saldo/this.detail.detail[index].detail_total_in_dus)

          }
          this.process.load = false
        })
      },
      reset (index) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.rejected_reason = ''

        this.process.form = false

        this.message.error = ''
      },
      onImageLoad(e) {
        const img = e.target
        this.imageAspectRatio = img.naturalWidth / img.naturalHeight
      },
      onImageLoadAkta(e) {
        const img = e.target
        this.imageAspectRatioAkta = img.naturalWidth / img.naturalHeight
      },
      async toTerima () {
        this.message.error = ''
        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.dialog.status = true; 
          this.message.status = 'terima'
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }

      },

      async save () {
        this.message.error = ''
        // const isValid = await this.$refs.form.validate()
        const isValid = true
        if (isValid) {
          

        this.process.form = true
        let approved_reason = {
          name: '',
          reason: ''
        }
        if (this.message.status === 'terima') {
          if(this.approved_by.length === 1 && this.approved_by[0] === 'Supervisor') {

            approved_reason = {
              name: 'Supervisor',
              reason: this.approved_reason
            }
          } else if(this.approved_by.length === 1 && this.approved_by[0] === 'Sales Manager') {
            approved_reason = {
              name: 'Sales Manager',
              reason: this.approved_reason
            }
          } else if(this.approved_by.length > 1) {
            approved_reason = {
              name: 'all',
              reason: this.approved_reason
            }
          } 
        }

        await post(`admin/order/approval_warehouse`, {
          data: {
            id: this.detail.id,
            varian_arr: JSON.stringify(this.detail.detail.map((item) => {
              return {
                varian_id: item.detail_varian_id,
                qty_pcs_approve: item.qty_pcs_approve,
                qty_lusin_approve: item.qty_lusin_approve,
                qty_dus_approve: item.qty_dus_approve,
                total_in_dus: item.detail_total_in_dus,
              }
            })),
          }
        }).then(response => {
          let res = response.data

          this.process.form = false

          if (res.status === 200) {

            this.dialog.status = false

            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetchDetail()
          } else {
            this.message.error = res.message
          }
        })
          
      }

        
      }
    }
  }
</script>

<style>
table, th, td {
    /* border: 1px solid #ededed;
    border-collapse: collapse; */
    /* border: thin ridge black; */
    border-spacing: 4px;
    border-collapse: collapse;
  }
</style>